import { Box, Stack, Typography } from '@mui/material'

import { ButtonMenu } from '@/components/componentLibrary/ButtonMenu'
import { ICON_MAP } from '@/components/componentLibrary/Icon/Icons'
import { PermissionKey } from '@/modules/api/openapi/models/PermissionKey'
import { useAuth } from '@/modules/authentication'
import { GlobalModalId, useGlobalModalProvider } from '@/modules/globalModal/context'
import { useProfilePageAccess } from '@/modules/urlRouting/utils'
import { useCurrentUser, usePermission } from '@/modules/user/hooks'

const SettingsIcon = () => {
  const {
    data: { email },
  } = useCurrentUser()

  return (
    <Stack
      sx={theme => ({
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      {/* A letter in an avatar, not a heading: a heading here breaks the page's heading order. */}
      <Typography variant="h6" component="span" color="white" fontWeight="bold">
        {email.charAt(0).toUpperCase()}
      </Typography>
    </Stack>
  )
}

const SettingsMenu = () => {
  const { setId } = useGlobalModalProvider()
  const { signOut } = useAuth()
  const hasProfilePageAccess = useProfilePageAccess()
  const hasAdmin = usePermission(PermissionKey.IS_ADMIN)

  const options = [
    ...(hasProfilePageAccess
      ? [
          {
            text: 'Account',
            onClick: () => setId(GlobalModalId.PROFILE_SETTINGS),
            Icon: <ICON_MAP.manageAccount />,
          },
        ]
      : []),
    ...(hasAdmin
      ? [
          {
            text: 'Admin',
            onClick: () =>
              window.open(
                import.meta.env.DEV
                  ? `${window.location.protocol}//${window.location.hostname}:8000/admin`
                  : `${window.location.origin}/admin`,
                '_blank'
              ),
            Icon: <ICON_MAP.settings />,
          },
        ]
      : []),
    {
      text: 'Sign Out',
      onClick: signOut,
      Icon: <ICON_MAP.logout />,
    },
  ]

  return <ButtonMenu label="Settings" options={options} Icon={<SettingsIcon />} portalIntoHeader />
}

export default SettingsMenu
